import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { skusQueryOptions } from '../../../../-hooks/useSkusQuery';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/skus/active/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      skusQueryOptions({ ...deps, isArchived: false }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/SkusTab'),
    'SkusTab',
  ),
});
